<mat-toolbar class="no-background">
  <span>問い合わせ作成</span>
  <span class="spacer"></span>
  <a mat-button class="add-link" routerLink="/inquiry">
    <mat-icon>arrow_back</mat-icon>作成せずに戻る
  </a>
</mat-toolbar>

<form [formGroup]="form" (ngSubmit)="submit()" enctype="multipart/form-data">

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>タイトル（入力必須・100文字まで・お問い合わせ内容の概略をご記入ください）</mat-label>
    <input matInput formControlName="title" maxlength="100" required>
    <mat-hint align="end">
      <span *ngIf="form.get('title')?.invalid && form.get('title')?.touched" class="inline-error">
        タイトルは必須です　
      </span>
      <span *ngIf="form.get('title')?.hasError('maxlength') && form.get('title')?.touched" class="inline-error">
        タイトルは100文字以内で入力してください　
      </span>
      {{ form.get('title')?.value?.length || 0 }}/100
    </mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>口座番号（特定の口座についてお問い合わせの場合は必ずご記入ください・50文字まで）</mat-label>
    <input matInput formControlName="acc" maxlength="50">
    <mat-hint align="end">
      <span *ngIf="form.get('acc')?.hasError('maxlength') && form.get('acc')?.touched" class="inline-error">
        口座番号は50文字以内で入力してください　
      </span>
      {{ form.get('acc')?.value?.length || 0 }}/50
    </mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>本文（入力必須・1000文字まで・簡潔にお問い合わせ内容をご記入ください）</mat-label>
    <textarea matInput formControlName="body" rows="6" required></textarea>
    <mat-hint align="end">
      <span *ngIf="form.get('body')?.invalid && form.get('body')?.touched" class="inline-error">
        本文は必須です　
      </span>
      <span *ngIf="form.get('body')?.hasError('maxlength') && form.get('body')?.touched" class="inline-error">
        本文は1000文字以内で入力してください　
      </span>
      {{ form.get('body')?.value?.length || 0 }}/1000
    </mat-hint>
  </mat-form-field>

  <input type="file" #fileInput hidden multiple (change)="onFileChange($event)"/>

  <div
    class="drop-zone"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)"
  >
    <p>ここにファイルをドロップまたは</p>
    <button mat-raised-button color="primary" type="button" (click)="fileInput.click()">ファイルを選択</button>
    <p></p>
    <p>※ファイルは最大10個まで、1ファイルにつき20MB以内でアップロードしてください</p>

    <div *ngIf="selectedFiles.length > 0" class="mt-2">
      <mat-list>
        <mat-list-item *ngFor="let file of selectedFiles; let i = index">
          <div class="file-row">
            <button mat-icon-button color="warn" type="button" (click)="removeFile(i)" aria-label="削除">
              <mat-icon>delete</mat-icon>
            </button>
            <span class="file-size">
              ({{ file.size / (1024 * 1024) | number : '1.2-2' }} MB)
            </span>
            <span class="file-name">
              {{ file.name }}
            </span>
          </div>
        </mat-list-item>
      </mat-list>
    </div>

  </div>

  <mat-error *ngIf="form.get('files')?.hasError('maxFileSize')">
    {{ form.get('files')?.getError('maxFileSize')?.message }}
  </mat-error>

  <div style="text-align: right;">
    <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">
      問合せを登録
    </button>
  </div>

</form>
